import { ChangeDetectorRef, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { RoutingConfig } from '@app/routing/routing.config';
import { DevicesClass } from '@app/core/classes';
import { StorageService } from '@app/core/services';

@Component({
  selector: 'shared-cookies-contract',
  templateUrl: 'cookies-contract.component.html',
  styleUrls: [`./cookies-contract.component.scss`],
  encapsulation: ViewEncapsulation.None
})

export class CookiesContractComponent extends DevicesClass  implements OnInit {
  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    private storageService: StorageService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.onCheckViewPopup) {
      return;
    }
    this.onInitCookiesTemplate();
  }

  onInitCookiesTemplate(): void {
    if (document.querySelector('.cookies-contract')) {
      return;
    }
    const bodyElement: HTMLCollection = document.getElementsByTagName('body');
    const insertElement = document.createElement('div');

    insertElement.className = 'cookies-contract animated faster slideInLeft delay-1s';
    insertElement.innerHTML = `
      <div class="cookies-contract__content">
        <div class="col-9 col-sm-8">
          <p>
            Наш сайт использует файлы cookie.
            Продолжая использовать наш сайт, Вы выражаете согласие на обработку фалов "cookie" и подтверждаете, что ознакомились с 
            <a href="/${RoutingConfig.Pages}/${RoutingConfig.CookiesContract}">Политикой использования Cookie</a>
          </p>
        </div>
        <div class="col-3 col-sm-4">
          <button class="ui-buttons ui-buttons__light-small __js__accept-cookie">Согласен</button>
        </div>
      </div>
    `;

    for (const i of Object.keys(bodyElement)) {
      /**
       * Create cookiePopup template.
       */
      bodyElement[i].append(insertElement);


      /**
       * Button accept event listener.
       */
      setTimeout(() => {
        const buttonElement = document.querySelector('.__js__accept-cookie');

        buttonElement.addEventListener('click', e => {
          insertElement.remove();
          this.onAcceptCookieHandler();
        });
      }, 100);
    }
  }

  onAcceptCookieHandler(): void {
    this.storageService.setCookie({
      name: 'cookie-contract',
      value: true,
      expires: 10
    });
  }

  get onCheckViewPopup(): boolean {
    return this.storageService.checkCookie('cookie-contract');
  }
}
